import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, Download, Loader2, X, BookOpen } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const EBOOK_URL = "/SI-Ebook-Abrir-uma-Agencia.pdf";
const EMPTY = { name: "", email: "", phone: "" };

export const EbookGate = ({ open, onClose }) => {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  if (!open) return null;

  const download = () => {
    const a = document.createElement("a");
    a.href = EBOOK_URL;
    a.download = "SI-Ebook-Abrir-uma-Agencia.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await axios.post(`${API}/api/leads`, { ...f, city: "", interest: "ebook", message: "Download do ebook: Abrir uma agência" });
      setState("done");
      setTimeout(download, 600);
    } catch (err) {
      setState("idle");
      toast.error(err?.response?.status === 422 ? "Verifique os dados preenchidos." : "Não foi possível enviar. Tente novamente.");
    }
  };

  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-navy/80 p-4 backdrop-blur-sm" data-testid="ebook-gate-overlay" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} data-testid="ebook-gate-modal" className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-[28px] bg-navy-card p-7 text-white ring-1 ring-white/15 sm:p-10">
        <button onClick={onClose} data-testid="ebook-gate-close" className="absolute right-5 top-5 rounded-full border border-white/20 p-2 text-slate-300 hover:text-white" aria-label="Fechar">
          <X className="h-4 w-4" />
        </button>

        {state !== "done" ? (
          <>
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-orange/15 text-orange ring-1 ring-orange/40"><BookOpen className="h-5 w-5" /></span>
            <h3 className="mt-5 font-display text-2xl font-black sm:text-3xl">Abrir uma agência</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300 sm:text-base">Deixe o seu nome, email e contacto para descarregar gratuitamente o ebook da Soluções Ideais.</p>
            <form onSubmit={submit} data-testid="ebook-gate-form" className="mt-6 space-y-5">
              {[
                ["name", "Nome", "O seu nome", "text"],
                ["email", "Email", "nome@email.pt", "email"],
                ["phone", "Contacto", "+351 9XX XXX XXX", "tel"],
              ].map(([k, label, ph, type]) => (
                <label key={k} className="block">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300">{label}</span>
                  <input data-testid={`ebook-gate-${k}-input`} required={k !== "name"} type={type} value={f[k]} onChange={set(k)} placeholder={ph} className="mt-2 w-full border-b border-white/25 bg-transparent py-3 text-lg text-white outline-none transition-[border-color] duration-300 placeholder:text-slate-500 focus:border-orange" />
                </label>
              ))}
              <button disabled={state === "loading"} data-testid="ebook-gate-submit" className="flex w-full items-center justify-center gap-3 rounded-full bg-orange py-4 font-display text-base font-black uppercase tracking-wide text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-orange-deep disabled:opacity-70">
                {state === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : <>Descarregar o ebook <Download className="h-5 w-5" /></>}
              </button>
            </form>
          </>
        ) : (
          <div className="py-6 text-center">
            <CheckCircle2 className="mx-auto h-11 w-11 text-orange" />
            <h3 className="mt-5 font-display text-2xl font-black">Ebook a caminho, {f.name.split(" ")[0]}.</h3>
            <p className="mt-2 text-sm text-slate-300">O download começou automaticamente. Se não começou, use o botão abaixo.</p>
            <a href={EBOOK_URL} download data-testid="ebook-gate-download" className="mt-6 inline-flex items-center gap-3 rounded-full bg-orange px-7 py-3.5 font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-orange-deep">
              <Download className="h-5 w-5" /> Descarregar o ebook
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
